import React, { FunctionComponent } from 'react';
import FormField from 'components/form-field/form-field';
import { CompanyFormFields } from 'modules/company/types/companyFormFields.type';
import { useFormikContext } from 'formik';

type Props = {
  isDisabled: boolean;
};

export const CompanyNameField: FunctionComponent<Props> = ({ isDisabled }) => {
  const { setFieldValue } = useFormikContext<CompanyFormFields>();

  return (
    <FormField
      disabled={isDisabled}
      name="name"
      type="text"
      onChange={(event): void => {
        setFieldValue('name', event.target.value.toUpperCase());
      }}
      label="Nom de l'entreprise"
      required
    />
  );
};
